import type { FaireProductEntity } from "../../entity_types/product";

export const p_uzy9awfjr8: FaireProductEntity = {
  token: "p_uzy9awfjr8",
  type: "product",
  name: "Ceriello Homemade Vodka Sauce",
  brandToken: "b_9d6nx4c74q",
  brandName: "Ceriello Fine Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/4f650d3ebd4dd1a2c2530bcfaf485fc6c658282d542e6722b77f9ff91c246a4a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/82f819aacd0fb154a8b89406b271d77f0ae3c75a18bfe171a57d72fbcad5d28a.png",
    "https://cdn.faire.com/fastly/d7f6aa285f36310b152e11281372712f2ee900f05e584e4c01a816aa95d5f160.jpeg",
  ],
  priceDollars: 4,
  description:
    'We have been making these sauces in our store kitchen for over 20 years--hand-stirred and hand-filled in heat-sealed jars. We use only Italian-grown San-Marzano Style tomatoes, fresh produce and top-quality spices.\n\nSlightly chunky tomatoes mixed with fresh shitake mushrooms, heavy cream, butter, and the flavor of vodka make this pink sauce one of our most popular. Adaptable in all of your recipes, try adding sautéed finely chopped prosciutto or whole shrimp to create a simple, yet magnificent main course.\n\nOur kitchen is NY State inspected and USDA inspected. Sealed jars are shelf-stable for 2 years and good in the refrigerator, after opening, for about a week. A 15oz jar is good for about one pound of pasta (3-4 people). A 30oz jar for about two pounds (7-8 people).\n\nUse Discount Code "CASE" take $1 off each bottle of dressing or sauce when you buy 12.\n*Discount already included on whole case purchases* \n\n\nVegetarian. No sugar, wheat, or nut products added, though we are not an allergen-free environment.\n',
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:06.394Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
